export enum CompanyTabsContentBlock {
  Root = 'CompanyTabsContent',
}

export enum CompanyTabsContentElement {
  Navigation = 'navigation',
}
